import { ref } from 'vue';
import commercialWidgetsAPI from 'dashboard/api/commercialWidgets';

export const useCommercialWidgets = () => {
  const widgets = ref([]);
  const slots = ref(0);
  const columns = ref(0);
  const catalog = ref(null);
  const isLoading = ref(false);

  const applyList = ({ data }) => {
    widgets.value = data.widgets;
    slots.value = data.slots;
    columns.value = data.columns;
  };

  const fetchWidgets = async () => {
    isLoading.value = true;
    try {
      applyList(await commercialWidgetsAPI.list());
    } finally {
      isLoading.value = false;
    }
  };

  const fetchCatalog = async () => {
    const { data } = await commercialWidgetsAPI.getCatalog();
    catalog.value = data;
  };

  const removeWidget = async id => {
    await commercialWidgetsAPI.destroy(id);
    widgets.value = widgets.value.filter(widget => widget.id !== id);
  };

  // Otimista: aplica o novo layout na hora; se a API falhar reverte (em 422 adota
  // os widgets que o servidor devolve) e repropaga o erro para quem chamou.
  const reorder = async newPositions => {
    const previous = widgets.value;
    widgets.value = previous.map(widget => ({
      ...widget,
      ...newPositions.find(item => item.id === widget.id),
    }));
    try {
      applyList(await commercialWidgetsAPI.reorder(newPositions));
    } catch (error) {
      widgets.value = error.response?.data?.widgets ?? previous;
      throw error;
    }
  };

  return {
    widgets,
    slots,
    columns,
    catalog,
    isLoading,
    fetchWidgets,
    fetchCatalog,
    removeWidget,
    reorder,
  };
};
